import {makeStyles} from "@material-ui/core/styles";
import Modal from "../generales/ModalCerrarActualiza";
import {useEffect, useState} from "react";
import {FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField} from "@material-ui/core";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment/moment";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import {toast} from "react-toastify";
import SelectEdo from '../generales/SelectEdo';
import { obtenDispo } from '../funciones/IdDispositivo';
import {useHistory} from "react-router-dom";
import axios from "axios";

const useStyles = makeStyles((theme) => ({}));

const ModalNuevoEditRecorrido = ({abrirModal, setAbrirModal, idusu,  latitud, longitud,actualiza, auxRegistro}) => {
    const history = useHistory();
    const classes = useStyles();
    const source = axios.CancelToken.source();

    let usuTipo = localStorage.getItem('Tipo');
    let fecha = Date.now()
    const auxDispV =obtenDispo() 
    const [selectedDate, handleDateChange] = useState(fecha);
    const [listSecc, setListSecc] = useState([])    
    const [auxListSecc, setAuxListSecc] = useState([])
    const [listDistrito, setListDistrito] = useState([])
    const [listTipo, setListTipo] = useState([])
    const [nuevoRegistro, setNuevoRegistro] = useState({
        Estado: process.env.REACT_APP_EDO,
        Municipio: '', 
        Tipo: '',
        Latitud: latitud,
        Longitud: longitud,
        Fecha: '',
        Direccion: '',
        Observacion: '',
        seccion:"",
        Distrito:"",
        Cantidad:"",
    });
    const {Distrito,seccion, Municipio, Tipo, Longitud, Latitud, Fecha, Direccion, Observacion, Cantidad} = nuevoRegistro
    const [btnDeshabilitado, setBotonDeshabilitado] = useState(false)
    const [aviso, setAviso] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [cargando, setCargando] = useState(false);

    const handleClose = () => {
        setAbrirModal(false)
        setAviso(false);
    }

    useEffect(() => {
        getListDto()
        getListSecc()
        if (auxRegistro) {
            
            //console.log(auxRegistro);
            setNuevoRegistro({  Municipio: auxRegistro.MuniId, Tipo: auxRegistro.TipoId, 
                Latitud: auxRegistro.Lat, Longitud: auxRegistro.Lon,
                Fecha:auxRegistro.FReg, Direccion: auxRegistro.Direcc,
                Observacion: auxRegistro.Obsrv, seccion:auxRegistro.SeccId,
                Distrito:auxRegistro.DtoId, Cantidad:auxRegistro.Cantidad,})
         
        }
        if (listTipo.length === 0) {
            recuperarTipo()
        }
    }, []);

    function getListDto()  {            
        const url= `lugar/municipio/distrito`;                            
        const data = qs.stringify({                
            Usuario:idusu,              
            Estado:process.env.REACT_APP_EDO,                                                
            ip:"127.0.0.0",
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   
                let listNvo=[]
                aux.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom}`})
                });
                setListDistrito(listNvo) 
                //filtroMun(aux)               
            }  
            else{
                setListDistrito([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    function getListSecc()  {            
        const url= `lugar/seccion/municipio`;                            
        const data = qs.stringify({                
            Usuario:idusu,              
            Municipio:34,                                                
            ip:"127.0.0.0",
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   
                if (auxRegistro) {
                    const filtro= aux.filter((secc)=> secc.DtoLocId === auxRegistro.DtoId)
                    setListSecc(filtro)
                    //console.log(filtro);
                    
                }
                
                setAuxListSecc(aux)                              
            }  
            else{
                setAuxListSecc([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    const recuperarTipo = () => {
        const data = qs.stringify({
            Usuario: idusu,
            idDispositivo: auxDispV
        });
        const url = "recorrido-tipo";

        function respuesta(response) {
            if (response[0].Id != -1) {
                setListTipo(response)
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    };

    const onChangeDto = (e) => {
        if (e !== null && e !== undefined) {
            const filtro= auxListSecc.filter((secc)=> secc.DtoLocId ===e.target.value)
            //console.log(filtro);
            
            setNuevoRegistro({
                ...nuevoRegistro,
                Distrito: e.target.value,
                seccion: ""
            })
            setListSecc(filtro)
            setMensaje('');
            setAviso(false);
        } else {
            setNuevoRegistro({
                ...nuevoRegistro,Distrito:"",
                seccion: ""
            })
            setListSecc([])
        }
    }

     const onChangeSecc = (e) => {
        if (e !== null && e !== undefined) {
            setNuevoRegistro({
                ...nuevoRegistro,
                seccion: e.target.value
            })
            setMensaje('');
            setAviso(false);
        } else {
            setNuevoRegistro({
                ...nuevoRegistro,
                seccion: ""
            })
        }
    }

    const onChange = e => {
        setNuevoRegistro({...nuevoRegistro,[e.target.name]: e.target.value})
    }



    const guardarRecorrido = () => {
        setCargando(true)
       // setBotonDeshabilitado(true);

        const data = !auxRegistro ? qs.stringify({
            Usuario: idusu,
            Edo: process.env.REACT_APP_EDO,
            Muni: 34,
            Seccion: seccion,
            fecha: moment(selectedDate).format("YYYY-MM-DD") + 'T00:00:00',
            latitud: Latitud,
            longitud: Longitud,
            AntLat:0.0,
            AntLon:0.0,
            ManualDir:"",
            Cantidad:Cantidad,
            Tipo: Tipo,
            Direccion: Direccion,
            Observ: Observacion,
            Manual:1,
            idDispositivo: auxDispV
        }) 
        : qs.stringify({
            Usuario:idusu,
            Llave:auxRegistro.Id,
            Sec:seccion,
            Cantidad:Cantidad,
            Direccion:Direccion,
            Observ:Observacion,
            idDispositivo:auxDispV,
            ip:"127.0.0.0"
        });

        const url = !auxRegistro? "recorrido/v7/new" : "recorrido/v3/edit";

        function respuesta(response) {
            if (response.respuesta === 1) {
                setAviso(true)
                const mensaje = !auxRegistro? "Recorrido agregado correctamente" : "Recorrido editado correctamente"
                toast.success(mensaje, {
                    pauseOnFocusLoss: false,
                    toastId: `nvo-recorrido${1}`
                })
                actualiza()
                setAbrirModal(false)
            } else {
               // setBotonDeshabilitado(false);
                toast.error('Datos incorrectos, intente mas tarde', {
                    pauseOnFocusLoss: false,
                    toastId: `error-recorrido${1}`
                })
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    }

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;        
          
        if( (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;        
          //  console.log(campo+' '+descripcion);                  
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }

    function guardarDatos(e) {
        e.preventDefault()
        if (!verificaNulos(Distrito,"Distrito") && 
            !verificaNulos(seccion,"Sección") && 
            !verificaNulos(Tipo,"Tipo") && 
             !verificaNulos(Cantidad,"Cantidad") &&
            !verificaNulos(Direccion,"Dirección") ) 
        {   //console.log("prueba",nuevoRegistro);
            setAviso(false);
            guardarRecorrido()
           // console.log( moment(selectedDate).format("YYYY-MM-DD") + 'T00:00:00');
        }  
    }

    return (
    <Modal
        titulo={auxRegistro? `Editar ${moment.utc(auxRegistro?.FEnv).local(true).format("DD/MM/YYYY HH:mm")}`:'Nuevo Registro'} modalAbierto={abrirModal} mensaje={mensaje}
        setModalAbierto={setAbrirModal} guardarDatos={guardarDatos}
        tipoAdvertencia={tipoAdvertencia} aviso={aviso} tamanio={'sm'}
        btnDeshabilitado={btnDeshabilitado} setAviso={setAviso}
        cargando={cargando} cerrarBorrar={handleClose}
    >
        <Grid container alignItems={'center'} spacing={1}>
            <Grid item xs={3}>
                {listDistrito.length !== 0 ?
                    <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '8rem'}}
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={Distrito} onChange={onChangeDto}
                            fullWidth
                        >
                            {listDistrito.map((dto, index) => {
                                return (
                                <MenuItem size='small' value={dto.Id} key={dto.Id}>
                                    <em>{dto.cadena}</em>
                                </MenuItem>
                                )
                                }
                            )}
                        </Select>
                    </FormControl>
                    : <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '8rem'}} 
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={Distrito} onChange={onChangeDto}
                            fullWidth
                        >
                            <MenuItem size='small' value={''}>
                                <em></em>
                            </MenuItem>
                        </Select>
                    </FormControl>
                }
            </Grid>
            <Grid item xs={3}>
                {listSecc.length !== 0 && Distrito !==""?
                    <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="seccion-label-nvo">Sección</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '8rem'}}
                            label="Sección" id="Sección-select2" name="seccion"
                            value={seccion} onChange={onChangeSecc}
                            fullWidth
                        >
                            {listSecc.map((dto, index) => {
                                return (
                                <MenuItem size='small' value={dto.Id} key={dto.Id}>
                                    <em>{dto.Numero}</em>
                                </MenuItem>
                                )
                                }
                            )}
                        </Select>
                    </FormControl>
                    : <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="seccion-label-vacio">Sección</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '8rem'}} 
                            label="Sección" id="seccion-select2" name="seccion"
                            value={seccion} onChange={onChangeSecc}
                            fullWidth
                        >
                            <MenuItem size='small' value={''}>
                                <em></em>
                            </MenuItem>
                        </Select>
                    </FormControl>
                }
            </Grid>
            <Grid item xs={5}>
                {listTipo.length !== 0 ?
                <FormControl size="small">
                    <InputLabel htmlFor="Tipo">Tipo</InputLabel>
                    <Select native value={Tipo} fullWidth onChange={onChange}
                        inputProps={{name: 'Tipo', id: 'Tipo',}} style={{width:"10rem"}}
                    >
                        {listTipo.map(element => {
                            return <option key={element.Id} value={element.Id}>
                                {element.Nom}</option>
                        })}
                    </Select>
                </FormControl>
                : null
                }
            </Grid>
          
            <Grid item xs={4} style={{marginBottom:.5+'rem',marginTop:.5+'rem'}}>
                <TextField id="Cantidadtxt" name="Cantidad" label="Cantidad" fullWidth size="small"
                    type="number"
                    value={Cantidad} onChange={onChange} variant="outlined"/>
            </Grid>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                    <DatePicker
                        disableFuture label="Fecha"
                        format="dd/MM/yyyy" size="small"
                        views={["year", "month", "date"]}                                                
                        minDate="2017-03-14" maxDate={new Date()}
                        value={selectedDate} onChange={handleDateChange}
                        style={{width: 6.5 + 'rem'}}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} style={{marginBottom:.5+'rem',marginTop:.5+'rem'}}>
                <TextField id="Direccion" name="Direccion" label="Dirección" fullWidth size="small"
                    value={Direccion} onChange={onChange} variant="outlined"/>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="Observacion" name="Observacion"
                    label="Observación" variant="outlined"
                    multiline fullWidth onChange={onChange}
                    rows={4} value={Observacion}
                />
            </Grid>
        </Grid>
    </Modal>);
};

export default ModalNuevoEditRecorrido;
